import React, { Component } from "react";
import Cost_center from "../../../components/Cost_center/Cost_center";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : AccountingForm
Description : Compoente que alberga el resto del formulario de registro definido en el directorio de componentes
Date Autor Modification
================================================================================
04/11/2021 Cristian Andres Pizo Mina – Se llama al componente de Accounting con sus respectivos parámetros.
================================================================================ */

class Cost_centerForm extends Component{
    constructor(props){
        super(props);
    }
    render(){
        return(
            <Cost_center/>
        )
    }
}

export default Cost_centerForm;